import {HybirdBridge, invoke} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";

export class FlutterVersionManager extends BridgeMethod {

  constructor() {
    super();
  }

  /**
   * 切换环境
   * @param params
   */
  async switchEnv(params) {
    return invoke("switchEnv", {
      params
    })
  }

  /**
   * 获取环境配置
   */
  async getEnvConfig() {
    return invoke("getEnvConfig")
  }

  /**
   * 更新版本
   * @param type 1:app 2:h5
   * @param options 选项对象
   * @param options.number 印控仪设备编号 (默认值: "")
   * @param options.onProgress 进度回调函数 (可选)
   * @return {Promise<{
   *   code:int,//返回的code码
   *   data:Object, //type=1 为int, 升级使用的id   type=2  String 更新的地址
   *   event: {String:String} //当前调用产生的event
   * }>}
   */
  async updateVersion(type = 1, {number = "", onProgress} = {}) {
    return invoke("updateVersion", {
      params: {
        type,
        number
      },
      on: {
        onProgress
      }
    })
  }

  /**
   * 验证版本最新
   * @param type 1:app 2:h5
   * @param onProgress
   * @return {Promise<{
   *   code:int,//返回的code码
   *   data:Object, //type=1 为int, 升级使用的id   type=2  String 更新的地址
   *   event: {String:String} //当前调用产生的event
   * }>}
   */
  async checkVersion(type = 1, number) {
    return invoke("checkVersion", {
      params: {
        type,
        number
      }
    })
  }

  /**
   * 安卓升级的一些方法
   * @param id updateVersion中的data
   * @param type 1:安装 2:继续下载  3:取消 4:暂停
   * @return {Promise<void>}
   */
  async upgradeWithId(id, type = 1) {
    return invoke("upgradeWithId", {
      params: {
        id, type
      }
    })
  }

}

export const flutterVersionManager = new FlutterVersionManager();